<template>
    <cic-popup
        :saveable="templateId > 0 && selected.length > 0"
        class="no-padding"
        title="Apply Template"
        @blur="$emit('blur')"
        @input="handleApply"
    >
        <ul class="item-form" style="padding: 10px 10px 10px 26px">
            <li class="form-label-first">{{ $t('Licence Template') }}</li>
            <li>
                <cic-select
                    id="licence_template"
                    :value="templateId"
                    :options="templates.map((x) => ({ value: x.templateId, label: x.name }))"
                    @input="(val) => (templateId = val)"
                />
            </li>
            <li class="form-label">{{ $t('Licence Expiry') }}</li>
            <li>
                <cic-select
                    id="licence_expiry"
                    :value="expiry"
                    :options="[
                        { value: 1, label: $t('Closest to expiry') },
                        { value: -1, label: $t('Furthest from expiry') },
                    ]"
                    @input="(val) => (expiry = val)"
                />
            </li>
        </ul>
        <table id="tblTemplateUser" class="cic-table">
            <thead>
                <tr>
                    <th>{{ $t('User') }}</th>
                    <th style="width: 90px">{{ $t('Apply') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ $t('[All]') }}</td>
                    <td>
                        <cic-checkbox
                            :value="selected.length === users.length"
                            @input="(val) => handleClick(-1, val)"
                        />
                    </td>
                </tr>
                <tr v-for="user in users">
                    <td>{{ formatUsername(user) }}</td>
                    <td>
                        <cic-checkbox
                            :value="selected.includes(user.userId)"
                            @input="(val) => handleClick(user.userId, val)"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </cic-popup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicSelect from '@/components/inputs/CicSelect';
    import { formatUsername } from '../LicenceUtils';

    export default {
        name: 'EditUserTemplate',
        components: {
            CicSelect,
            CicCheckbox,
            CicPopup,
        },
        props: {
            licences: {
                type: Array,
                required: true,
            },
            quantities: {
                type: Array,
                required: true,
            },
            templates: {
                type: Array,
                required: true,
            },
            users: {
                type: Array,
                required: true,
            },
        },
        emits: ['blur', 'input'],
        data() {
            return {
                expiry: 1,
                selected: [],
                templateId: null,
            };
        },
        methods: {
            formatUsername,
            handleApply() {
                const alerts = [];
                const licenceTemplate = this.templates.find((x) => x.templateId === this.templateId);
                const quantities = this.quantities.filter((x) => licenceTemplate.quantities.includes(x.quantityId));
                quantities.forEach((x) => {
                    const assigned = this.selected.filter((y) => !this.hasLicence(y, x.quantityId, [])).length;
                    if (assigned > x.total - x.assigned) {
                        alerts.push(
                            this.$t('For [x], [y] licences are required, but only [z] are available.')
                                .replace(/\[x]/g, x.name)
                                .replace(/\[y]/g, assigned)
                                .replace(/\[z]/g, x.total - x.assigned),
                        );
                    }
                });

                if (
                    alerts.length === 0 ||
                    confirm(this.$t('APPLY_TEMPLATE_CONFIRM').replace(/\[x]/g, '\n' + alerts.join('\n')))
                ) {
                    const assignments = [];
                    const licences = this.licences
                        .filter((x) => licenceTemplate.quantities.includes(x.quantityId))
                        .sort((a, b) => (a.end > b.end ? this.expiry : -this.expiry));
                    this.selected.forEach((x) => {
                        let guids = [];
                        const quantityIds = this.licences
                            .filter((y) => y.assigned.includes(x))
                            .map((y) => y.quantityId);
                        const available = licenceTemplate.quantities
                            .filter((y) => !quantityIds.includes(y))
                            .map((y) => this.getAvailable(y, licences, assignments))
                            .filter((y) => y);
                        quantities.forEach((y) => {
                            if (
                                !quantityIds.includes(y.quantityId) &&
                                available.find((z) => z.quantityId === y.quantityId) &&
                                available.filter((z) => y.allRequired.includes(z.quantityId)).length ===
                                    y.allRequired.length
                            ) {
                                guids.push(available.find((z) => z.quantityId === y.quantityId).id);
                            }
                        });
                        if (guids.length > 0) {
                            assignments.push({ userId: x, ids: guids });
                        }
                    });

                    this.$emit('input', assignments);
                }
            },
            handleClick(userId, val) {
                if (val) {
                    if (userId === -1) {
                        this.selected = this.users.map((x) => x.userId);
                    } else {
                        this.selected.push(userId);
                    }
                } else {
                    if (userId === -1) {
                        this.selected = [];
                    } else {
                        this.selected.splice(this.selected.indexOf(userId), 1);
                    }
                }
            },
            getAvailable(quantityId, licences, assignments) {
                return licences.find(
                    (x) =>
                        x.quantityId === quantityId &&
                        x.assigned.length + assignments.filter((y) => y.ids.includes(x.id)).length < x.quantity,
                );
            },
            hasLicence(userId, quantityId, assigned) {
                return (
                    this.licences.some((x) => x.quantityId === quantityId && x.assigned.includes(userId)) ||
                    assigned.includes(quantityId)
                );
            },
        },
    };
</script>
